import {
  uint8,
  uint16,
  uint32,
  int8,
  int16,
  int32,
  parseVersion,
  saveMap
} from '../utils';
import dataItemStyle from './dataItemStyle';
import { Description } from '@/types/watchface';
import {
  IMG,
  LAYOUT,
  IMG_ARRAY,
  SPRITE,
  DATA,
  WIDGET,
  SLOT
} from './dataSource';
import {
  getThemeTableTotalCount,
  getThemeTableLength,
  RECORD_LENGTH,
  THEME_TABLE_PER_ROW_LENGTH,
  THEME_TABLE_PRE_LENGTH
} from './constant';

export const genM62DataBinary = (data: any) => {
  const dataBin: Buffer[] = [];
  data.forEach((item: any) => {
    const { type } = item;
    console.log('item', item, Buffer.concat(dataBin).length);
    switch (type) {
      case IMG:
        {
          const imgBin = Buffer.concat([
            uint8(item.fmtIndex === undefined ? 0 : item.fmtIndex), // fmt
            uint8(0), // reserved1
            uint16(0), // reserved
            uint16(item.width),
            uint16(item.height),
            uint32(item.dataLength),
            item.imgData
          ]);
          dataBin.push(imgBin);
        }
        break;
      case LAYOUT:
        {
          const defaultIndex = Number(item.defaultIndex || 0);
          const layoutBin = Buffer.concat([
            item.resUid,
            uint16(item.x || 0),
            uint16(item.y || 0),
            uint32(defaultIndex), //parameter: bit[7:0]为默认展示项index，bit[31:8] reserved
            uint32(0) //reserved
          ]);
          dataBin.push(layoutBin);
        }
        break;
      case IMG_ARRAY:
        {
          const fmt = uint8(item.fmtIndex === undefined ? 0 : item.fmtIndex);
          // imgNumber 改为保留字段
          const imgNumber = uint8(item.imgNumber);
          const reserved = uint16(0);
          const imgWidth = uint16(item.width);
          const imgHeight = uint16(item.height);
          const dataLength = uint32(item.dataLength);
          const imgData = item.imgData;

          const imgArrBin = Buffer.concat([
            fmt,
            imgNumber,
            reserved,
            imgWidth,
            imgHeight,
            dataLength,
            imgData
          ]);
          dataBin.push(imgArrBin);
        }
        break;

      case SPRITE:
        {
          const imgArrUid = item.uidImgArray;
          // imgNumber 改为保留字段
          const imgNum = uint8(0);
          // flags=1表示复杂动画，目前不支持复杂动画
          const flags = uint8(0);
          const interval = uint16(item.interval);
          const repeatCount = uint32(item.repeatCount);

          const spriteBin = Buffer.concat([
            imgArrUid,
            imgNum,
            flags,
            interval,
            repeatCount
          ]);
          dataBin.push(spriteBin);
        }
        break;

      case DATA:
        {
          const { tag } = item;
          switch (tag) {
            case 'DataItemImageValues':
              {
                const imgValuesSourceId = uint16(dataItemStyle[item.source]);
                const imgValuesDigits = uint8(0);
                const imgValuesFlags = uint8((2 << 4) + 0);
                const imgValuesPrivate = uint32(0);
                const imgValuesRecordBinary = Buffer.concat([
                  imgValuesSourceId,
                  imgValuesDigits,
                  imgValuesFlags,
                  imgValuesPrivate
                ]);

                const imgValuesImgArrUid = item.uidImgArray;
                const imgValuesReserved = uint8(0);
                const tableFlags = uint8(item.flags);
                const imgValuesRotation = uint16(item.rotation);
                const dataTable = item.dataTable;
                const imgValuesDataStyleBinary = Buffer.concat([
                  imgValuesImgArrUid,
                  imgValuesReserved,
                  tableFlags,
                  imgValuesRotation,
                  dataTable
                ]);

                const imgValuesDataBinary = Buffer.concat([
                  imgValuesRecordBinary,
                  imgValuesDataStyleBinary
                ]);
                dataBin.push(imgValuesDataBinary);
              }
              break;

            case 'DataItemImageNumber':
              {
                const imgNumSourceId = uint16(dataItemStyle[item.source]);
                // digits中 3:0总位数 7:4小数位数
                const imgNumDigits = uint8(
                  (Number(item.decimalDigits) << 4) + Number(item.totalDigits)
                );
                // 1:0 00右 01左 10中
                let alignFlag = 0;
                if (item.align === 'right') {
                  alignFlag = 0;
                } else if (item.align === 'left') {
                  alignFlag = 1;
                } else if (item.align === 'center') {
                  alignFlag = 2;
                }
                const leadingZeroFlag = item.leadingZero === 'true' ? 1 : 0;
                const trailingZeroFlag = item.trailingZero === 'true' ? 1 : 0;
                const imgNumFlags = uint8(
                  (1 << 4) +
                    (trailingZeroFlag << 3) +
                    (leadingZeroFlag << 2) +
                    alignFlag
                );
                const imgNumPrivate = uint32(0);
                const imgNumRecordBinary = Buffer.concat([
                  imgNumSourceId,
                  imgNumDigits,
                  imgNumFlags,
                  imgNumPrivate
                ]);

                const imgNumImgArrUid = item.uidImgArray;
                const imgNumreserved = uint8(0);
                const space = int8(item.space);
                const imgNumRotation = uint16(item.rotation);
                const uidUnitIcon = item.unitIcon ? item.unitIcon : uint32(0);
                const imgNumDataStyleBinary = Buffer.concat([
                  imgNumImgArrUid,
                  imgNumreserved,
                  space,
                  imgNumRotation,
                  uidUnitIcon
                ]);

                const imgNumDataBinary = Buffer.concat([
                  imgNumRecordBinary,
                  imgNumDataStyleBinary
                ]);
                dataBin.push(imgNumDataBinary);
              }
              break;
            case 'DataItemPointer':
              {
                const dataRecordBinary = Buffer.concat([
                  uint16(dataItemStyle[item.source]),
                  uint8(0), // digits
                  uint8(0b00110000), //private
                  uint32(0)
                ]);

                const valueStartB = Object.is(parseInt(item.valueStart), NaN)
                  ? int32(dataItemStyle[item.valueStart])
                  : int32(item.valueStart * 256);
                const valueRangeB = Object.is(parseInt(item.valueRange), NaN)
                  ? int32(dataItemStyle[item.valueRange])
                  : int32(item.valueRange * 256);
                const centorXB = int16(item.pivotX);
                const centorYB = int16(item.pivotY);
                const angleStartB = int16(item.angleStart * 10);
                const angleRangeB = int16(item.angleRange * 10);
                const reserved = uint32(0);
                const dataStyleBinary = Buffer.concat([
                  item.pointerRefImg,
                  valueStartB,
                  valueRangeB,
                  centorXB,
                  centorYB,
                  angleStartB,
                  angleRangeB,
                  reserved
                ]);

                const dataBinary = Buffer.concat([
                  dataRecordBinary,
                  dataStyleBinary
                ]);
                dataBin.push(dataBinary);
              }

              break;
            case 'DataItemArcProgressBar':
              {
                const arcSourceId = uint16(dataItemStyle[item.source]);
                const arcDigits = uint8(0);
                const arcFlags = uint8((4 << 4) + 0);
                const arcPrivate = uint32(0);
                const arcRecordBinary = Buffer.concat([
                  arcSourceId,
                  arcDigits,
                  arcFlags,
                  arcPrivate
                ]);

                const fgImgUid = item.uidFgImg;
                const bgImgUid = item.uidBgImg ? item.uidBgImg : uint32(0);
                const arcLineCapFlag = item.endingStyle === 'round' ? 1 : 0;
                const arcPointerFlag = item.uidIndicatorImg ? 1 : 0;
                const arcStyleFlags = uint32(
                  (arcPointerFlag << 1) + arcLineCapFlag
                );
                const arcValueStart = int32(item.valueStart * 256);
                const arcValueRange = int32(item.valueRange * 256);
                const arcCentorX = int16(item.pivotX);
                const arcCentorY = int16(item.pivotY);
                const arcAngleStart = int16(item.angleStart * 10);
                const arcAngleRange = int16(item.angleRange * 10);
                const arcBarRadius = int16(item.barRadius);
                const arcBarWidth = int16(item.barWidth);

                const indicator = [];
                // 有indicator才有如下字段
                if (arcPointerFlag) {
                  const arcIndicatorImgUid = item.uidIndicatorImg;
                  const arcIndicatorRadius = int16(item.indicatorRadius);
                  const reserved1 = int16(0);
                  const reserved2 = uint32(0);
                  indicator.push(
                    arcIndicatorImgUid,
                    arcIndicatorRadius,
                    reserved1,
                    reserved2
                  );
                }
                const indicatorBinary = Buffer.concat(indicator);
                const arcDataStyleBinary = Buffer.concat([
                  fgImgUid,
                  bgImgUid,
                  arcStyleFlags,
                  arcValueStart,
                  arcValueRange,
                  arcCentorX,
                  arcCentorY,
                  arcAngleStart,
                  arcAngleRange,
                  arcBarRadius,
                  arcBarWidth,
                  item.uidIndicatorImg ? indicatorBinary : Buffer.alloc(0)
                ]);
                const arcDataBinary = Buffer.concat([
                  arcRecordBinary,
                  arcDataStyleBinary
                ]);
                dataBin.push(arcDataBinary);
              }
              break;
            case 'DataItemLineProgressBar':
              {
                const lineSourceId = uint16(dataItemStyle[item.source]);
                const lineDigits = uint8(0);
                const lineFlags = uint8((5 << 4) + 0);
                const linePrivate = uint32(0);
                const lineRecordBinary = Buffer.concat([
                  lineSourceId,
                  lineDigits,
                  lineFlags,
                  linePrivate
                ]);

                const linefgImgUid = item.uidFgImg;
                const lineBgImgUid = item.uidBgImg ? item.uidBgImg : uint32(0);
                const lineLineCapFlag = item.endingStyle === 'round' ? 1 : 0;
                const linePointerFlag = item.indicatorRelateUid ? 1 : 0;
                const lineStyleFlags = uint32(
                  (linePointerFlag << 1) + lineLineCapFlag
                );
                const lineValueStart = int32(item.valueStart * 256);
                const lineValueRange = int32(item.valueRange * 256);
                const lineStartX = int16(item.startX);
                const lineStartY = int16(item.startY);
                const lineEndX = int16(item.endX);
                const lineEndY = int16(item.endY);
                const lineReserved = uint16(0);
                const lineBarWidth = uint16(item.barWidth);

                const lineIndicator = [];
                if (linePointerFlag) {
                  const lineIndicatorImgUid = item.indicatorRelateUid;
                  const lineOffsetX = linePointerFlag
                    ? int16(item.indicatorOffsetX)
                    : int16(0);
                  const lineOffsetY = linePointerFlag
                    ? int16(item.indicatorOffsetY)
                    : int16(0);
                  const lineReserved2 = uint32(0);
                  lineIndicator.push(
                    lineIndicatorImgUid,
                    lineOffsetX,
                    lineOffsetY,
                    lineReserved2
                  );
                }
                const lineIndicatorBinary = Buffer.concat(lineIndicator);
                const lineDataStyleBinary = Buffer.concat([
                  linefgImgUid,
                  lineBgImgUid,
                  lineStyleFlags,
                  lineValueStart,
                  lineValueRange,
                  lineStartX,
                  lineStartY,
                  lineEndX,
                  lineEndY,
                  lineReserved,
                  lineBarWidth,
                  item.indicatorRelateUid
                    ? lineIndicatorBinary
                    : Buffer.alloc(0)
                ]);
                const lineDataBinary = Buffer.concat([
                  lineRecordBinary,
                  lineDataStyleBinary
                ]);
                dataBin.push(lineDataBinary);
              }
              break;
            default:
              break;
          }
        }
        break;
      case WIDGET:
        {
          const widgetName = Buffer.alloc(32);
          if (item.widgetName) {
            widgetName.write(item.widgetName);
          }
          let widgetBg;
          if (item.bg) {
            widgetBg = item.bg;
          } else if (item.bgColor) {
            //如果存在bgColor的话
            widgetBg = uint32(item.bgColor);
          } else {
            widgetBg = uint32(0);
          }
          const widgetUidPreviewImg = item.preview ? item.preview : uint32(0);
          const widgetRecordCount = uint8(item.uidTable.length);
          const widgetReserved = uint8(0);
          const bgFlag = item.bg ? 0 : 1;
          const enableJumpFlag = 0;
          const widgetFlags = uint16((enableJumpFlag << 1) + bgFlag);
          const widgetRecordTable = item.dataTable;

          const widgetDataBinary = Buffer.concat([
            widgetName,
            widgetBg,
            widgetUidPreviewImg,
            widgetRecordCount,
            widgetReserved,
            widgetFlags,
            widgetRecordTable
          ]);
          dataBin.push(widgetDataBinary);
        }
        break;
      case SLOT:
        {
          const widgetCount = uint8(item.slotItemUidTable.length);
          const slotReserved = uint8(0);
          const slotFlags = uint16(0);
          const slotUidWidgets = item.slotItemUidData;

          const slotDataBinary = Buffer.concat([
            widgetCount,
            slotReserved,
            slotFlags,
            slotUidWidgets
          ]);
          dataBin.push(slotDataBinary);
        }
        break;
      default:
        break;
    }
  });

  return Buffer.concat(dataBin);
};

export const genM62HeaderBinary = (
  themeNum: number,
  basicInfo: Description,
  isAlbum: boolean,
  isEditable: boolean
) => {
  const {
    version,
    pkgName,
    editorVersion: romVersion,
    name: watchName
  } = basicInfo;
  const magicWord = uint32(0x1234a55a);
  const watchFaceVerision = version ? parseVersion(version) : 0;
  const firmWareVersion = romVersion ? parseVersion(romVersion) : 0;

  const watchface = uint32(watchFaceVerision);
  const editor = uint32(0);
  const generator = uint32(0);
  const protocol = uint32(0x00000701);
  const versionFirmware = uint32(firmWareVersion);

  const checksum = uint32(0); //在6.0.3中删除
  const themeCount = uint8(themeNum);
  const defaultTheme = uint8(0); //在6.0.3中删除

  let flags = isAlbum ? 1 : 0;
  flags = isEditable ? flags + 0x2 : flags & ~0x2; // 设置flags的1bit 是否editable
  const previewImgArrayAddr = uint32(248);
  const reserved = uint32(0);

  const id = Buffer.alloc(64);
  const name = Buffer.alloc(64);
  if (pkgName) id.write(pkgName);
  if (watchName) name.write(watchName);

  const headerBin = Buffer.concat([
    magicWord,
    watchface,
    editor,
    generator,
    protocol,
    versionFirmware,
    checksum,
    themeCount,
    defaultTheme,
    uint16(flags),
    previewImgArrayAddr,
    reserved,
    id,
    name
  ]);
  return { headerBin, headerLength: 168 };
};

export const genM62ThemeAndRecordBinary = async (
  themeData: any,
  themeNum: number,
  HEADER_LENGTH: number,
  xmlPath?: string
) => {
  let totalRecordNum = 0;
  const themeTableLength = getThemeTableLength();
  const recordStartAddr = HEADER_LENGTH + themeNum * themeTableLength;
  let recordsOffset = 0;
  const previewAddressArr: any[] = [];
  const themeTableArr = Object.entries(themeData).map(
    ([themeType, value]: [string, any]) => {
      if (!value.records.length) return Buffer.alloc(0);
      console.log(value);
      totalRecordNum += value.records.length;
      const themeTable = Buffer.alloc(themeTableLength);
      // v0.70 新增bgColor，previewImgDataAddr字段
      let bgColor = 0;
      if (value.bgColor) {
        bgColor = Number(`0x${value.bgColor.slice(1)}`);
        themeTable.writeUInt32LE(bgColor, 0);
      } else {
        value.records.forEach((elem: any) => {
          if (
            elem.name &&
            value.bg &&
            elem.name.indexOf(value.bg.substring(1)) >= 0 &&
            elem.type === 2
          ) {
            const uid = elem.uid.readInt32LE();

            themeTable.writeUInt32LE(uid, 0);
          }
        });
      }

      for (let i = 0; i < getThemeTableTotalCount(); i++) {
        themeTable.writeUInt32LE(
          value.recordsCount[i],
          i * THEME_TABLE_PER_ROW_LENGTH + THEME_TABLE_PRE_LENGTH
        );
        themeTable.writeUInt32LE(
          recordStartAddr + recordsOffset,
          i * THEME_TABLE_PER_ROW_LENGTH + 4 + THEME_TABLE_PRE_LENGTH
        );
        recordsOffset += value.recordsCount[i] * RECORD_LENGTH;
      }
      const preview = value.preview;
      if (preview && preview !== '') {
        previewAddressArr.push(value.previewAddr);
      } else previewAddressArr.push(undefined);
      return themeTable;
    }
  );

  const dataOffset =
    HEADER_LENGTH +
    themeNum * themeTableLength +
    totalRecordNum * RECORD_LENGTH;

  const recordsArr: Buffer[] = [];
  const nameArr: string[] = [];
  const uidArr: any[] = [];
  Object.entries(themeData).forEach(([key, value]: [string, any]) => {
    value.records.forEach((record: any) => {
      if (record.type !== 0) {
        const name = record.name;
        if (!nameArr.includes(name) || record.colorGroup) {
          const mapUid = Buffer.from(record.uid)
            .reverse()
            .toString('hex')
            .slice(1);
          nameArr.push(name);
          uidArr.push(mapUid);
        }
      }
      const flags = uint32(0);
      const dataAddress = uint32(record.dataAddress + dataOffset);
      const dataLength = uint32(record.dataLength);
      const recordBin = Buffer.concat([
        record.uid,
        flags,
        dataAddress,
        dataLength
      ]);
      recordsArr.push(recordBin);
    });
  });

  xmlPath && (await saveMap(xmlPath, nameArr, uidArr));
  return Buffer.concat([...themeTableArr, ...recordsArr]);
};
